import isJSON from 'validator/lib/isJSON'
import isEmail from 'validator/lib/isEmail'
import isInt from 'validator/lib/isInt'

import isValue from 'type/value/is'
import isDate from 'type/date/is'
import isArray from 'type/array/is'

export const UTILS__VALIDATOR__is_email = data => {
    return isEmail(data)
}
export const UTILS__VALIDATOR__is_value = data => {
    return isValue(data)
}
export const UTILS__VALIDATOR__is_date = data => {
    return isDate(data)
}
export const UTILS__VALIDATOR__is_json = data => {
    return isJSON(data)
}
export const UTILS__VALIDATOR__is_int = data => {
    return isInt(data)
}
export const UTILS__VALIDATOR__is_array = data => {
    return isArray(data)
}

export const UTILS__VALIDATOR__validate_email = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}
